import { TAResponseProps } from 'types/TextAnalysis'
import { textAnalysisTemplate } from '../Template'
import { getOwnerType } from '../Helpers/Helper'
import { Content } from '../Types'

export const renderCardTitleContent = ({
  attributes: { associations, contents },
}: TAResponseProps) => {
  const { owner, parent } = associations
  const ownerType = getOwnerType(owner)

  if (ownerType === 'survey') {
    return parent?.name || ''
  }

  if (ownerType === 'brainstormer') {
    const title = contents.find(
      (content: Content) =>
        content.attribute === textAnalysisTemplate.attributeTitle,
    )
    return title?.value || ''
  }

  return ''
}

export const renderCardBodyContent = ({
  attributes: { contents },
}: TAResponseProps) => {
  const description = contents.find(
    (content: Content) =>
      content.attribute === textAnalysisTemplate.attributeDesc,
  )

  return description?.value || ''
}

export const renderCardTitleLink = ({
  attributes: { associations, references },
}: TAResponseProps) => {
  const { parent } = associations

  // Check if the parent type is 'Idea' and the entity_type is 'Comment'
  const isParentIdea = parent?.type?.toLowerCase() === 'idea'
  const hasCommentReference = references?.some(
    (ref: any) => ref.entity_type.toLowerCase() === 'comment',
  )

  const text = isParentIdea && hasCommentReference ? `${parent.name}` : ''

  return text
}
